if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      }

      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            /* Veluna Motion: Pfoten-Animation abspielen, dann zum Warenkorb */
            const goToCart = () => { window.location = window.routes.cart_url; };
            if (window.velunaAddedToCart) { window.velunaAddedToCart(this.submitButton, goToCart); } else { goToCart(); }
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          if (!this.error && window.velunaAddedToCart) window.velunaAddedToCart(this.submitButton, null);
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* ===== Veluna Motion (06.10.2026): Einblenden beim Scrollen + Pfoten-Animation beim Warenkorb =====
   Zum Deaktivieren: diesen ganzen Block bis zum Ende der Datei loeschen
   und in onSubmitHandler die zwei Zeilen mit velunaAddedToCart entfernen. */
(function () {
  if (window.__velunaMotion) return;
  window.__velunaMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;

  var css = '.vm-reveal{opacity:0;transform:translateY(28px);transition:opacity .6s ease,transform .6s ease}' +
    '.vm-reveal.vm-in{opacity:1;transform:none}' +
    '.vm-paw{position:fixed;left:0;top:0;width:34px;height:34px;margin:-17px 0 0 -17px;z-index:2147483000;pointer-events:none}' +
    '@keyframes vmPop{0%{transform:scale(1)}40%{transform:scale(1.3)}100%{transform:scale(1)}}' +
    '.vm-pop{animation:vmPop .35s ease}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var PAW = '<svg viewBox="0 0 40 40" width="34" height="34" aria-hidden="true"><g fill="#6b8a73">' +
    '<ellipse cx="20" cy="27" rx="9" ry="7.5"/><ellipse cx="9" cy="17" rx="3.6" ry="4.6"/>' +
    '<ellipse cx="16" cy="10.5" rx="3.6" ry="4.8"/><ellipse cx="24" cy="10.5" rx="3.6" ry="4.8"/>' +
    '<ellipse cx="31" cy="17" rx="3.6" ry="4.6"/></g></svg>';

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < (window.innerHeight || 800);
  }

  /* 1 - Abschnitte unterhalb des sichtbaren Bereichs gleiten beim Scrollen herein */
  function initReveal() {
    if (reduce || design || !('IntersectionObserver' in window)) return;
    if (location.pathname.indexOf('/products/') === -1) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vm-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(main.children, function (sec) {
      if (!sec.classList || !sec.classList.contains('shopify-section')) return;
      if (sec.querySelector('product-info, .product__info-wrapper')) return;
      if (sec.getBoundingClientRect().top < vh * 0.9) return;
      sec.classList.add('vm-reveal');
      io.observe(sec);
    });
  }

  /* 2 - Pfote huepft vom Button zum Warenkorb-Symbol */
  var lastBtn = null, lastAt = 0;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[type="submit"], button[name="add"]');
    if (b) { lastBtn = b; lastAt = Date.now(); }
  }, true);

  window.velunaAddedToCart = function (formBtn, done) {
    var called = false;
    function finish() { if (called) return; called = true; if (done) done(); }
    try {
      var btn = (lastBtn && Date.now() - lastAt < 4000 && visible(lastBtn)) ? lastBtn : formBtn;
      var label = btn && btn.querySelector('span:not(.hidden):not(.sold-out-message)');
      if (label) {
        var alt = label.textContent;
        label.textContent = '✓ Hinzugefügt';
        if (!done) setTimeout(function () { label.textContent = alt; }, 1800);
      }
      if (reduce || !btn || !document.body.animate) { setTimeout(finish, done ? 450 : 0); return; }
      var r = btn.getBoundingClientRect();
      var sx = r.left + r.width / 2, sy = r.top + r.height / 2;
      var cart = document.getElementById('cart-icon-bubble');
      var tx, ty;
      if (visible(cart)) {
        var c = cart.getBoundingClientRect();
        tx = c.left + c.width / 2; ty = c.top + c.height / 2;
      } else {
        cart = null; tx = sx + 40; ty = Math.max(20, sy - 160);
      }
      var paw = document.createElement('div');
      paw.className = 'vm-paw';
      paw.innerHTML = PAW;
      document.body.appendChild(paw);
      var mx = (sx + tx) / 2, my = Math.min(sy, ty) - 80;
      var anim = paw.animate([
        { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(.4) rotate(-20deg)', opacity: 0 },
        { transform: 'translate(' + sx + 'px,' + (sy - 30) + 'px) scale(1.15) rotate(-10deg)', opacity: 1, offset: 0.2 },
        { transform: 'translate(' + mx + 'px,' + my + 'px) scale(1) rotate(10deg)', opacity: 1, offset: 0.6 },
        { transform: 'translate(' + tx + 'px,' + ty + 'px) scale(.45) rotate(20deg)', opacity: 0 }
      ], { duration: 800, easing: 'ease-in-out', fill: 'forwards' });
      anim.onfinish = function () {
        if (paw.parentNode) paw.remove();
        if (cart) { cart.classList.remove('vm-pop'); void cart.offsetWidth; cart.classList.add('vm-pop'); }
        setTimeout(finish, 150);
      };
      setTimeout(function () { if (paw.parentNode) paw.remove(); finish(); }, 1400);
    } catch (err) { finish(); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveal); else initReveal();
})();
